import { createAction } from '@reduxjs/toolkit';

const ontoAction = {
  SET_PAGENAME: createAction<string>('SET_PAGENAME'),
};
export default ontoAction;
